// @flow
import { attemptLoadCountryConfig, loadCountryConfig } from './actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { ATTEMPTS_BEFORE_FAIL } from './constants';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import type { LoadCountryConfigAction } from './types';
import { logIn } from '~/core/state/application/actions';
import toResult from '../toResult';

export function* loadCountryConfigSaga({ payload: { user } }: LoadCountryConfigAction): Generator<Effect, *, *> {
    yield put(attemptLoadCountryConfig());

    // Since this is a critical part of the app startup we want to give this
    // a few attempts to make it more resilient.

    for (let i = 0; i < ATTEMPTS_BEFORE_FAIL; i++) {
        const [countryConfig, err] = yield call(toResult(loadCountry), user.countryCode);

        if (!err) {
            return yield put(loadCountryConfig(countryConfig.default));
        }

        yield i < ATTEMPTS_BEFORE_FAIL - 1 ? call(delay, 2000) : put(loadCountryConfig(err));
    }
}

function* watchChangeUserSaga(): Generator<Effect, *, *> {
    yield takeEvery(logIn, handleSaga(loadCountryConfigSaga));
}

export function loadCountry(country: string): Promise<*> {
    return import(`../../config/countries/${country.toLowerCase()}`);
}

export default [watchChangeUserSaga];



// WEBPACK FOOTER //
// ./src/core/state/config/sagas.js